import { NgClass } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { DialogTableDataRow } from '../../../content/interfaces/dialog-table-data-row';
import { I18nService } from '../../../core/services/i18n.service';
import { SpsMaskedPasswordComponent } from '../sps-masked-password/sps-masked-password.component';

@Component({
  selector: 'sps-data-view-table',
  imports: [
    PrimeTemplate,
    TableModule,
    NgClass,
    SpsMaskedPasswordComponent
  ],
  templateUrl: './sps-data-view-table.component.html',
})
export class SpsDataViewTableComponent {

  i18n = inject(I18nService);

  @Input() headerTitle: string = '';
  @Input() headerTitleKey: string = null;
  @Input() tableData: DialogTableDataRow[] = [];
  @Input() titleColumnWidth: string = 'auto';
  @Input() valueColumnWidth: string = 'auto';

  /**
   * mask or unmask password
   */
  showPassword: boolean = false;

}
